var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6643 0.902983C23.9887 -0.300994 26.0113 -0.300994 27.3357 0.902983L48.8634 20.4736C50.2824 21.7636 50.3869 23.9596 49.097 25.3785C47.807 26.7975 45.611 26.902 44.1921 25.6121L25 8.16477L5.80791 25.6121C4.38896 26.902 2.19296 26.7975 0.903009 25.3785C-0.386944 23.9596 -0.282372 21.7636 1.13658 20.4736L22.6643 0.902983Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6475 31.3132C12.5652 31.3132 14.1197 32.8678 14.1197 34.7854V43.0556H35.879V34.7854C35.879 32.8678 37.4335 31.3132 39.3512 31.3132C41.2688 31.3132 42.8234 32.8678 42.8234 34.7854V46.5278C42.8234 48.4455 41.2688 50.0001 39.3512 50.0001H10.6475C8.72986 50.0001 7.17529 48.4455 7.17529 46.5278V34.7854C7.17529 32.8678 8.72986 31.3132 10.6475 31.3132Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.b73f6e824bed77124abef58034c8eb73.svg";
export { ForwardRef as ReactComponent };